/*    
<summary>
  This functional component shows the fota release details.
  Developer:Aashish Singh, Created Date: 05-Sept-2024
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../../contexts/StoreProvider";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import config from "../../../helpers/config-helper";
import userTypeEnum from "../../../constants/user-type-enum";
import {
  getUserTypeFromLocalStorage,
  getTenantIdFromLocalStorage,
} from "../../../helpers/local-stotrage-helper";
import { IFotaTenantReleaseList } from "../../../models/response/IFotaResponse";
import fotaFileTypeEnum from "../../../constants/fota-file-type-enum";

interface IProps {
  isModemView: boolean;
  selectedData: IFotaTenantReleaseList;
}

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

const FotaMzlDetails = (props: IProps) => {
  const { fotaMzlStore, tenantStore } = useStore();
  const {
    GetFotaMzlReleaseByIdService,
    getFotaMzlDetail,
    fotaMzlReleaseState
  } = fotaMzlStore;
  const { selectedTenantId } = tenantStore;

  /**
   * This function calls the "GetFotaTenantReleaseByIdService" store funtion that get group data from API
   */
  const callGetFotaById = (tenantId: number) => {
    GetFotaMzlReleaseByIdService(props.isModemView, props?.selectedData.Id);
  };

  useEffect(() => {
    if (props?.selectedData.Id > 0) {
      let tenantId: number =
        getUserTypeFromLocalStorage() === userTypeEnum.SystemUser
          ? selectedTenantId
          : getTenantIdFromLocalStorage();
      callGetFotaById(tenantId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.selectedData.Id]);

  return (
    <React.Fragment>
      {(fotaMzlReleaseState.inProgress) && (
        <FormLoader loading={fotaMzlReleaseState.inProgress} />
      )}
      {getFotaMzlDetail && (
        <div className="p-3">
          {
            getUserTypeFromLocalStorage() === userTypeEnum.TenantUser ?
            <div className="row pt-2">
              <div className="col-6">
                <label className="text-muted bold">
                  <FormattedMessage id="version" />:{" "}
                </label>
              </div>
              <div className="col-6">
                <p className="mw-100">
                  <span>
                    {getFotaMzlDetail.Version}
                  </span>
                </p>
              </div>
            </div> :
            <div className="row pt-2">
              <div className="col-6">
                <label className="text-muted bold">
                  <FormattedMessage id={"version"} />:{" "}
                </label>
              </div>
              <div className="col-6">
                <p className="mw-100">
                  <span>
                    {getFotaMzlDetail.Version}
                  </span>
                </p>
              </div>
            </div>
          }
          <div className="row pt-2">
            <div className="col-6">
            <label className="text-muted bold">
                <FormattedMessage id="file_type" />:{" "}
            </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                  <span>
                    {fotaFileTypeEnum[getFotaMzlDetail.FileType]}
                  </span>
              </p>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-6">
            <label className="text-muted bold">
                <FormattedMessage id="file_name" />:{" "}
            </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                  <span>
                    {getFotaMzlDetail.FileName}
                  </span>
              </p>
            </div>
          </div>
          {
            getFotaMzlDetail.UpdatedDate &&
            <div className="row pt-2">
                <div className="col-6">
                <label className="text-muted bold">
                    <FormattedMessage id={"created_date"} />:{" "}
                </label>
                </div>
                <div className="col-6">
                <p className="mw-100">
                    <span>
                      {getFotaMzlDetail.UpdatedDate}
                    </span>
                </p>
                </div>
            </div>
          }
          {
            getFotaMzlDetail.Description && 
              <div className="row pt-2">
                <div className="col-6">
                  <label className="text-muted bold">
                    <FormattedMessage id={"desc"} />:{" "}
                  </label>
                </div>
                  <div className="col-6">
                    <p className="mw-100">
                      <span>
                        {getFotaMzlDetail.Description}
                      </span>
                    </p>
                  </div>
              </div>
          }
        </div>
      )}
    </React.Fragment>
  );
};

export default observer(FotaMzlDetails);
